export enum ProductType_Enum {
  HP = 0,
  PCP = 1
}
